import "./App.css";
import ToDoContainer from "./components/ToDoContainer";

function App() {
  return (
    <div className="App">
      <ToDoContainer />
    </div>
  );
}

export default App;
